import { DNS_RESPONSE_CODES, HTTP_STATUS_CODES } from '@kentik/ui-shared/query/unitEnums';

// from rfc2616-sec10
// https://www.iana.org/assignments/http-status-codes/http-status-codes.xhtml
export const httpStatusCodes = Object.fromEntries(
  Object.entries(HTTP_STATUS_CODES).map(([code, info]) => [code, info.label])
);

// from http://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml#dns-parameters-6
export const dnsStatusCodes = Object.fromEntries(
  Object.entries(DNS_RESPONSE_CODES).map(([code, info]) => [code, { short: info.short, long: info.description }])
);
